export const benefitsPaths = {
  base: 'benefits',
  homeBenefits: 'homeBenefits',
  benefit: 'benefit',
  option: 'option',
};

export const benefitRoutes = {
  BenefitsHome: `/${benefitsPaths.base}/${benefitsPaths.homeBenefits}`,
  benefits: `/${benefitsPaths.base}/${benefitsPaths.benefit}`,
  optionBenefit: `/${benefitsPaths.base}/${benefitsPaths.option}`,
};
